/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReservationDurations200ResponseOneOf1ValuesInner } from './GetReservationDurations200ResponseOneOf1ValuesInner';
import {
    GetReservationDurations200ResponseOneOf1ValuesInnerFromJSON,
    GetReservationDurations200ResponseOneOf1ValuesInnerFromJSONTyped,
    GetReservationDurations200ResponseOneOf1ValuesInnerToJSON,
    GetReservationDurations200ResponseOneOf1ValuesInnerToJSONTyped,
} from './GetReservationDurations200ResponseOneOf1ValuesInner';

/**
 * 
 * @export
 * @interface GetReservationDurations200ResponseOneOf1
 */
export interface GetReservationDurations200ResponseOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetReservationDurations200ResponseOneOf1
     */
    type: GetReservationDurations200ResponseOneOf1TypeEnum;
    /**
     * 
     * @type {Array<GetReservationDurations200ResponseOneOf1ValuesInner>}
     * @memberof GetReservationDurations200ResponseOneOf1
     */
    values: Array<GetReservationDurations200ResponseOneOf1ValuesInner>;
}


/**
 * @export
 */
export const GetReservationDurations200ResponseOneOf1TypeEnum = {
    Quantity: 'QUANTITY'
} as const;
export type GetReservationDurations200ResponseOneOf1TypeEnum = typeof GetReservationDurations200ResponseOneOf1TypeEnum[keyof typeof GetReservationDurations200ResponseOneOf1TypeEnum];


/**
 * Check if a given object implements the GetReservationDurations200ResponseOneOf1 interface.
 */
export function instanceOfGetReservationDurations200ResponseOneOf1(value: object): value is GetReservationDurations200ResponseOneOf1 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function GetReservationDurations200ResponseOneOf1FromJSON(json: any): GetReservationDurations200ResponseOneOf1 {
    return GetReservationDurations200ResponseOneOf1FromJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationDurations200ResponseOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'values': ((json['values'] as Array<any>).map(GetReservationDurations200ResponseOneOf1ValuesInnerFromJSON)),
    };
}

export function GetReservationDurations200ResponseOneOf1ToJSON(json: any): GetReservationDurations200ResponseOneOf1 {
    return GetReservationDurations200ResponseOneOf1ToJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOf1ToJSONTyped(value?: GetReservationDurations200ResponseOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'values': ((value['values'] as Array<any>).map(GetReservationDurations200ResponseOneOf1ValuesInnerToJSON)),
    };
}

